import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpClient} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly excludeUrls: string[] = [
    '/ent/ent/student/app/api/v1/app/items/test-data',
  ];
  constructor(private router: Router, private http: HttpClient) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isExcluded = this.excludeUrls.some(excludePath => req.url.includes(excludePath));
    if (isExcluded) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if ((error.status === 401 || error.status === 403) && !localStorage.getItem('token')) {
          this.router.navigate(['/auth']);
        }
        return throwError(error);
      })
    );
  }
}
